import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { ProductionListConfFilter, ProductionListConfService } from './production-list-conf.service'
import { ProductionListScope } from './prod-list-scope'

@Directive({
  selector: '[appProductionListConfSelect]',
})
export class ProductionListConfSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const prodListConfService = inject(ProductionListConfService)
    this.select.displayProperty = 'id'
    this.select.placeholder = 'orders.prod.list.title'
    this.select.dataSource = prodListConfService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set scopes(scopes: ProductionListScope[]) {
    if (scopes) {
      this.select.filters = [ProductionListConfFilter.scopes(scopes)]
    }
  }
}
